import { Check, CreditCard, Minus, RefreshCcw, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

const PLANS = [
  {
    id: "free", name: "Free", price: "0", period: "per sempre",
    who: "Per provare l'officina digitale senza impegno: tre moduli operativi con pochi numeri.",
    features: [
      { ok: true, text: "Amministrazione e controllo: sedi, clienti e report produzione" },
      { ok: true, text: "Logistica generale e utensili: 1 magazzino, inventario, 50 utensili, 50 attacchi base" },
      { ok: true, text: "Produzione: 4 macchine, 2 componenti, 4 ordini cliente" },
      { ok: true, text: "2 utenti" },
      { ok: false, text: "Acquisti, Qualità, Preventivazione e Controllo di gestione non inclusi" },
    ],
    cta: "Inizia gratis",
  },
  {
    id: "easy_tool", name: "Easy Tool", price: "35", period: "al mese",
    who: "Per chi vuole solo il magazzino utensili in ordine, senza limiti di catalogo.",
    features: [
      { ok: true, text: "Logistica generale e utensili completa e senza limiti" },
      { ok: true, text: "Magazzini, posizioni, inventario e movimenti tracciati" },
      { ok: true, text: "Semilavorati e attrezzature di staffaggio con cartellino QR" },
      { ok: true, text: "Import Excel del catalogo e 4 utenti" },
      { ok: false, text: "Acquisti, Produzione, Qualità, Preventivazione e Controllo di gestione non inclusi" },
    ],
    cta: "Passa a Easy Tool",
  },
  {
    id: "standard", name: "Standard", price: "150", period: "al mese", featured: true,
    who: "Per l'officina che pianifica la produzione, compra e non vuole limiti su utensili, macchine e ordini.",
    features: [
      { ok: true, text: "Logistica generale e utensili e Produzione senza limiti" },
      { ok: true, text: "Acquisti e fornitori: listini, proposte di riordino, ordini e arrivo merce" },
      { ok: true, text: "Ordini cliente, OdP, planner settimanale e avanzamento officina" },
      { ok: true, text: "Amministrazione e controllo: sedi, clienti e report produzione" },
      { ok: true, text: "Fino a 8 utenti con ruoli e permessi" },
      { ok: false, text: "Qualità, Preventivazione e Controllo di gestione non inclusi" },
    ],
    cta: "Passa a Standard",
  },
  {
    id: "premium", name: "Premium", price: "250", period: "al mese",
    who: "Per chi vuole tutto: margini, preventivi, qualità e assistenza con priorità.",
    features: [
      { ok: true, text: "Tutti i sei moduli senza limiti, utenti illimitati" },
      { ok: true, text: "Controllo di gestione: margini, consuntivi utensili e materiale, alert direzionale" },
      { ok: true, text: "Preventivi con costo industriale, margine e offerta in PDF" },
      { ok: true, text: "Qualità: piani di controllo, controlli e non conformità" },
      { ok: true, text: "Acquisti e fornitori inclusi, assistenza prioritaria, corso di 2 giorni, 3 ticket gratuiti" },
    ],
    cta: "Richiedi Premium",
  },
];

const NOTES = [
  { icon: CreditCard, text: "Nessuna carta di credito per iniziare" },
  { icon: RefreshCcw, text: "Cambi piano quando vuoi" },
  { icon: ShieldCheck, text: "I tuoi dati restano tuoi: export Excel e PDF sempre disponibile" },
];

export function PricingSection() {
  return (
    <section className="landing-pricing" id="prezzi" data-testid="landing-pricing">
      <div className="landing-section-head landing-reveal">
        <p className="landing-module-num">PREZZI <i /> TRASPARENTI</p>
        <h2>Un piano per ogni dimensione di officina</h2>
        <p className="landing-desc">Sei moduli, quattro piani: parti gratis e aggiungi quello che ti serve. I limiti riguardano quanto carichi, non quanto vali.</p>
      </div>

      <div className="landing-plan-grid">
        {PLANS.map((plan, index) => (
          <article
            className={`landing-plan landing-reveal ${plan.featured ? "is-featured" : ""}`}
            style={{ transitionDelay: `${index * 90}ms` }}
            key={plan.id}
            data-testid={`pricing-card-${plan.id}`}
          >
            {plan.featured && <span className="landing-plan-badge" data-testid="pricing-badge-standard">PIÙ SCELTO</span>}
            <h3>{plan.name}</h3>
            <p className="landing-plan-price" data-testid={`pricing-price-${plan.id}`}>
              <b>{plan.price}&nbsp;€</b><small>{plan.period}</small>
            </p>
            <p className="landing-plan-who">{plan.who}</p>
            <ul className="landing-plan-features">
              {plan.features.map((feature) => (
                <li key={feature.text} className={feature.ok ? "" : "is-off"}>
                  {feature.ok ? <Check size={15} /> : <Minus size={15} />}<span>{feature.text}</span>
                </li>
              ))}
            </ul>
            <Link className="landing-plan-cta" to={`/registra-azienda?piano=${plan.id}`} data-testid={`pricing-cta-${plan.id}`}>{plan.cta}</Link>
          </article>
        ))}
      </div>

      <div className="landing-plan-notes landing-reveal" data-testid="pricing-notes">
        {NOTES.map(({ icon: Icon, text }) => (
          <span key={text}><Icon size={14} />{text}</span>
        ))}
      </div>
    </section>
  );
}
